import React from 'react';
import ProjectList from 'components/ProjectList';
import Footer from 'components/Footer';

function Projekte({ route }) {
    return (
        <div>
        <div>
            <h1>Projekte</h1>
            <ProjectList currentPath={route.path} pages={route.pages} />
        </div>
        <Footer />
        </div>
    );
}

export const data = {
    headImage: '01GoldenCityHafenbar',
};

export default Projekte;



// WEBPACK FOOTER //
// ./projekte/index.js